// extracted by mini-css-extract-plugin
module.exports = {"root":"IssuesListContainer_root__3pwrQ","progressBarWrap":"IssuesListContainer_progressBarWrap__3NTHM"};